import shatteredMemories from "../components/img/gallery/artwork/theater a1.png";
import veil1 from "../components/img/gallery/artwork/veil1.jpg";
import veil2 from "../components/img/gallery/artwork/veil2.jpg";
import veil3 from "../components/img/gallery/artwork/veil3.jpg";
import veil4 from "../components/img/gallery/artwork/veil4.jpg";
import photo1 from "../components/img/gallery/grid/1.jpg";
import photo2 from "../components/img/gallery/grid/2.jpg";
import photo3 from "../components/img/gallery/grid/3.jpg";
import photo4 from "../components/img/gallery/grid/4.jpg";
import photo5 from "../components/img/gallery/grid/5.jpg";
import photo6 from "../components/img/gallery/grid/6.png";
import photo7 from "../components/img/gallery/grid/7.JPG";
import photo9 from "../components/img/gallery/grid/9.jpg";
import photo10 from "../components/img/gallery/grid/10.jpg";
import photo11 from "../components/img/gallery/grid/11.jpg";
import photo12 from "../components/img/gallery/grid/12.jpg";
import photo13 from "../components/img/gallery/grid/13.jpg";
import photo14 from "../components/img/gallery/grid/14.jpg";
import photo15 from "../components/img/gallery/grid/15.jpg";
import photo16 from "../components/img/gallery/grid/16.jpg";
import photo17 from "../components/img/gallery/grid/17.jpg";
import photo18 from "../components/img/gallery/grid/18.jpg";
import photo19 from "../components/img/gallery/grid/19.jpg";
import photo20 from "../components/img/gallery/grid/20.jpg";
import photo21 from "../components/img/gallery/grid/21.jpg";

import thumb1 from "../components/img/gallery/grid/1.jpg";
import thumb2 from "../components/img/gallery/grid/2.jpg";
import thumb3 from "../components/img/gallery/grid/3.jpg";
import thumb4 from "../components/img/gallery/grid/4.jpg";
import thumb5 from "../components/img/gallery/grid/5.jpg";
import thumb6 from "../components/img/gallery/grid/6.png";
import thumb7 from "../components/img/gallery/grid/7.JPG";
import thumb9 from "../components/img/gallery/grid/9.jpg";
import thumb10 from "../components/img/gallery/grid/10.jpg";
import thumb11 from "../components/img/gallery/grid/11.jpg";
import thumb12 from "../components/img/gallery/grid/12.jpg";
import thumb13 from "../components/img/gallery/grid/13.jpg";
import thumb14 from "../components/img/gallery/grid/14.jpg";
import thumb15 from "../components/img/gallery/grid/15.jpg";
import thumb16 from "../components/img/gallery/grid/16.jpg";
import thumb17 from "../components/img/gallery/grid/17.jpg";
import thumb18 from "../components/img/gallery/grid/18.jpg";
import thumb19 from "../components/img/gallery/grid/19.jpg";
import thumb20 from "../components/img/gallery/grid/20.jpg";
import thumb21 from "../components/img/gallery/grid/21.jpg";

import th1 from "../components/img/gallery/artwork/veil1.jpg";
import th2 from "../components/img/gallery/artwork/veil2.jpg";
import th3 from "../components/img/gallery/artwork/veil3.jpg";
import th4 from "../components/img/gallery/artwork/veil4.jpg";

//artwork data for gallery component
export const artworkItems = [
  {
    title: "Shattered Memories",
    image: shatteredMemories,
    description: `“Memories are fragile, fragmented, and indelibly tied to the spaces we leave behind.”\n\n Shattered Memories is a dialogue between the past and the present. Using shards of glass salvaged from the Capitol Theater in Pretoria, these cyanotype prints capture the “ghosts” of the stage performances that ended decades ago but whose energy still resonates.\n\n Through long-exposure photography and historical materials, this collection evokes a sense of nostalgia and reflection. It asks the viewer: What layers of history are hidden in the places you walk every day?\n\n  I invite you to immerse yourself in these echoes. Reconnect with your own history and consider the stories that continue to shape our future.`,
  },
];

//bookm data for gallery component
// Add these to your photography array
export const photography = [
  {
    id: 1,
    title: "Veiled Realities",
    image: veil1,
    preview: th1,
    type: "item-type-1",
  },
  {
    id: 2,
    title: "Veiled Realities",
    image: veil2,
    preview: th2,
    type: "item-type-2",
  },
  {
    id: 3,
    title: "Veiled Realities",
    image: veil3,
    preview: th3,
    type: "item-type-3",
  },
  {
    id: 4,
    title: "Veiled Realities",
    image: veil4,
    preview: th4,
    type: "item-type-1",
  },
];

export const galleryItems = [
  // Photography items
  {
    id: 1,
    category: "Photography",
    title: "Makkita",
    image: photo1,
    thumbnail: thumb1,
  },
  {
    id: 2,
    category: "Photography",
    title: "Mongoose",
    image: photo2,
    thumbnail: thumb2,
  },
  {
    id: 3,
    category: "Photography",
    title: "Cars in the Park",
    image: photo3,
    thumbnail: thumb3,
  },
  {
    id: 4,
    category: "Photography",
    title: "Formula Vee",
    image: photo4,
    thumbnail: thumb4,
  },
  {
    id: 5,
    category: "Photography",
    title: "Formula Vee",
    image: photo5,
    thumbnail: thumb5,
  },
  {
    id: 6,
    category: "Photography",
    title: "Sky Tear",
    image: photo6,
    thumbnail: thumb6,
  },
  {
    id: 7,
    category: "Photography",
    title: "Predvill",
    image: photo7,
    thumbnail: thumb7,
  },
  {
    id: 9,
    category: "Photography",
    title: "Gio",
    image: photo9,
    thumbnail: thumb9,
  },
  {
    id: 10,
    category: "Photography",
    title: "Semokong",
    image: photo10,
    thumbnail: thumb10,
  },
  {
    id: 11,
    category: "Photography",
    title: "Black And White textures",
    image: photo11,
    thumbnail: thumb11,
  },
  {
    id: 12,
    category: "Photography",
    title: "Discovery",
    image: photo12,
    thumbnail: thumb12,
  },
  {
    id: 13,
    category: "Photography",
    title: "Sunset reflections",
    image: photo13,
    thumbnail: thumb13,
  },
  {
    id: 14,
    category: "Photography",
    title: "Formula Vee",
    image: photo14,
    thumbnail: thumb14,
  },
  {
    id: 15,
    category: "Photography",
    title: "Drone view",
    image: photo15,
    thumbnail: thumb15,
  },
  {
    id: 16,
    category: "Photography",
    title: "Self Portrait",
    image: photo16,
    thumbnail: thumb16,
  },
  {
    id: 17,
    category: "Photography",
    title: "Autume",
    image: photo17,
    thumbnail: thumb17,
  },
  {
    id: 18,
    category: "Photography",
    title: "Salomon",
    image: photo18,
    thumbnail: thumb18,
  },
  {
    id: 19,
    category: "Photography",
    title: "Sunset mountain",
    image: photo19,
    thumbnail: thumb19,
  },
  {
    id: 20,
    category: "Photography",
    title: "3M Self Portrait",
    image: photo20,
    thumbnail: thumb20,
  },
  {
    id: 21,
    category: "Photography",
    title: "Drakensberg",
    image: photo21,
    thumbnail: thumb21,
  },
];
